import { useRef, useState } from 'react';
import { useWindowSize } from '../../../hooks';
import type { UseDragResult } from './types';

export function useDrag(elementRef?: React.RefObject<HTMLElement>): UseDragResult {
  const elementWidth = elementRef?.current?.offsetWidth ?? 520;
  const elementHeight = elementRef?.current?.offsetHeight ?? 400;

  const isDragging = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const { width } = useWindowSize();
  const [position, setPosition] = useState({ x: width - elementWidth, y: 54 });

  const handleMouseDown = (event: React.MouseEvent): void => {
    isDragging.current = true;
    dragStart.current = {
      x: event.clientX - position.x,
      y: event.clientY - position.y
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (event: MouseEvent): void => {
    if (!isDragging.current) {
      return;
    }

    const newX = event.clientX - dragStart.current.x;
    const newY = event.clientY - dragStart.current.y;

    // 限制范围（防止拖出屏幕）
    const clampedX = Math.max(0, Math.min(newX, window.innerWidth - elementWidth));
    const clampedY = Math.max(0, Math.min(newY, window.innerHeight - elementHeight));

    setPosition({ x: clampedX, y: clampedY });
  };

  const handleMouseUp = (): void => {
    isDragging.current = false;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };

  return {
    handleMouseDown,
    position
  };
}
